import React, { useEffect } from 'react';
import { IconButton, Typography, Box } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import { Modal } from '../../../components/modals/Modal';
import PrivacyPolicy from '../../../pages/NewFigma/PrivacyPolicy';

export interface PrivacyPolicyModalProps {
  open: boolean;
  onClose: () => void;
}

export function PrivacyPolicyModal({ open, onClose }: PrivacyPolicyModalProps) {
  useEffect(() => {
    if (!open) return;

    let cancelled = false;
    let attempts = 0;
    let timeoutId: ReturnType<typeof setTimeout>;

    const tryScroll = () => {
      if (cancelled) return;

      const section = document.getElementById('aiConsent');
      if (section) {
        section.scrollIntoView({ behavior: 'smooth', block: 'start' });
        return;
      }

      attempts += 1;
      if (attempts < 20) {
        timeoutId = setTimeout(tryScroll, 50);
      }
    };

    timeoutId = setTimeout(tryScroll, 0);

    return () => {
      cancelled = true;
      clearTimeout(timeoutId);
    };
  }, [open]);

  return (
    <Modal
      open={open}
      onClose={onClose}
      sx={{
        zIndex: (theme) => theme.zIndex.modal + 1,
        '& > .MuiBox-root': {
          width: '100%',
          maxWidth: 900,
          borderRadius: '16px',
        },
      }}
    >
      <Modal.Header>
        <Box
          sx={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between',
            px: 2,
            py: 1.5,
            borderBottom: 1,
            borderColor: 'divider',
          }}
        >
          <Typography variant="h6" sx={{ fontWeight: 600 }}>
            Privacy Policy
          </Typography>
          <IconButton aria-label="Close privacy policy" onClick={onClose} size="small">
            <CloseIcon />
          </IconButton>
        </Box>
      </Modal.Header>
      <Modal.Body>
        <PrivacyPolicy variant="modal" />
      </Modal.Body>
    </Modal>
  );
}

export default PrivacyPolicyModal;
